import { difference } from 'lodash-es'
import { makeAutoObservable } from 'mobx'

class CheckSet<T> {
  allList: T[]
  disabledList: T[]
  checkSet: Set<T>
  unCheckSet: Set<T>
  disabledSet: Set<T>

  constructor(allList: T[] = [], initial: T[] = [], disabledList: T[] = []) {
    makeAutoObservable(this)

    this.disabledList = disabledList
    this.allList = allList
    this.checkSet = new Set(initial)
    this.unCheckSet = new Set(difference(this.allList, initial))
    this.disabledSet = new Set(disabledList)
  }

  get isFullyChecked() {
    return this.allList.length === this.checkSet.size + this.disabledSet.size
  }

  get isNoChecked() {
    return this.checkSet.size === 0
  }

  get isPartChecked() {
    return !this.isFullyChecked && !this.isNoChecked
  }

  get checkSize() {
    return this.checkSet.size
  }

  get toArray() {
    return [...this.checkSet]
  }

  get toUnCheckedArray() {
    return [...this.unCheckSet]
  }

  values() {
    return this.checkSet.values()
  }

  setCheck(value: T) {
    this.checkSet.add(value)
    this.unCheckSet.delete(value)
  }

  toggleCheck = (value: T) => {
    if (this.isChecked(value)) {
      this.deleteCheck(value)
    } else {
      this.setCheck(value)
      return 'UNCHECKED'
    }
  }

  deleteCheck = (value: T) => {
    if (this.disabledSet.has(value)) return 'DO_NOT_UNCHECK'
    this.checkSet.delete(value)
    this.unCheckSet.add(value)
    return 'UNCHECKED'
  }

  isChecked = (value: T) => {
    return this.checkSet.has(value)
  }

  isDisabled = (value: T) => {
    return this.disabledSet.has(value)
  }

  allCheck = () => {
    this.checkSet = new Set(difference(this.allList, this.disabledList))
    this.unCheckSet = new Set(difference(this.allList, this.toArray))
  }

  clearAllCheck = () => {
    this.checkSet.clear()
    this.unCheckSet = new Set(difference(this.allList, []))
  }

  toggleAllCheck = () => {
    this.isFullyChecked ? this.clearAllCheck() : this.allCheck()
  }

  setAllList(newAllList: T[]) {
    this.allList = newAllList
  }

  replaceSet(newList: T[]) {
    this.clearAllCheck()
    this.checkSet = new Set(newList)
  }
}

export default CheckSet
